/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchOperationsTimingSettings
 */
export interface MatchOperationsTimingSettings {
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsTimingSettings
     */
    matchId?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsTimingSettings
     */
    regularPeriodCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsTimingSettings
     */
    regularPeriodDurationMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MatchOperationsTimingSettings
     */
    overtimeEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsTimingSettings
     */
    overtimePeriodCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsTimingSettings
     */
    overtimePeriodDurationMinutes?: number;
}

/**
 * Check if a given object implements the MatchOperationsTimingSettings interface.
 */
export function instanceOfMatchOperationsTimingSettings(value: object): value is MatchOperationsTimingSettings {
    return true;
}

export function MatchOperationsTimingSettingsFromJSON(json: any): MatchOperationsTimingSettings {
    return MatchOperationsTimingSettingsFromJSONTyped(json, false);
}

export function MatchOperationsTimingSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationsTimingSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'] == null ? undefined : json['matchId'],
        'regularPeriodCount': json['regularPeriodCount'] == null ? undefined : json['regularPeriodCount'],
        'regularPeriodDurationMinutes': json['regularPeriodDurationMinutes'] == null ? undefined : json['regularPeriodDurationMinutes'],
        'overtimeEnabled': json['overtimeEnabled'] == null ? undefined : json['overtimeEnabled'],
        'overtimePeriodCount': json['overtimePeriodCount'] == null ? undefined : json['overtimePeriodCount'],
        'overtimePeriodDurationMinutes': json['overtimePeriodDurationMinutes'] == null ? undefined : json['overtimePeriodDurationMinutes'],
    };
}

export function MatchOperationsTimingSettingsToJSON(json: any): MatchOperationsTimingSettings {
    return MatchOperationsTimingSettingsToJSONTyped(json, false);
}

export function MatchOperationsTimingSettingsToJSONTyped(value?: MatchOperationsTimingSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'regularPeriodCount': value['regularPeriodCount'],
        'regularPeriodDurationMinutes': value['regularPeriodDurationMinutes'],
        'overtimeEnabled': value['overtimeEnabled'],
        'overtimePeriodCount': value['overtimePeriodCount'],
        'overtimePeriodDurationMinutes': value['overtimePeriodDurationMinutes'],
    };
}

